import cn from 'classnames';
import { memo, type HTMLAttributes, type ReactNode } from 'react';
import * as st from './styles.module.scss';

export type IconWithIndexPT = HTMLAttributes<HTMLDivElement> & {
  icon: ReactNode;
  iconIndex?: number;
  className?: string;
  indexClassName?: string;
  size?: 'small' | 'normal' | 'large';
};
export const IconInSquare = memo(
  ({ iconIndex, className, indexClassName, icon, size = 'normal', ...props }: IconWithIndexPT) => {
    return (
      <section className={cn(st.wrapper, st[size], className)} {...props}>
        {icon}
        {iconIndex && <p className={cn(st.index, indexClassName)}>{iconIndex}</p>}
      </section>
    );
  }
);
